var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 105 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.656,
    width: 20.833,
    height: 62.5,
    style: {
      fill: "rgb(38,166,154)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.667,
    y: 41.656,
    width: 20.833,
    height: 62.5,
    style: {
      fill: "rgb(38,166,154)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.833,
    height: 20.833,
    style: {
      fill: "rgb(38,166,154)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 41.667,
    width: 20.833,
    height: 20.833,
    style: {
      fill: "rgb(38,166,154)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.167,49.992C104.167,45.394 100.439,41.667 95.842,41.667L83.333,41.667L83.333,62.5L104.167,62.5L104.167,49.992Z",
    style: {
      fill: "rgb(38,166,154)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.333,
    y: 62.5,
    width: 20.833,
    height: 20.833,
    style: {
      fill: "rgb(38,166,154)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.333,
    y: 83.333,
    width: 20.833,
    height: 20.833,
    style: {
      fill: "rgb(38,166,154)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.422c3832a227f12f1a94798dd32d3dd9.svg";
export { ForwardRef as ReactComponent };